import React from 'react';
import { useTranslation } from 'react-i18next';
import { Field } from 'react-final-form';

import WithLabel, { LABEL_STYLES } from '../../../components/with-label/WithLabel';
import WithError from '../../../components/with-error/WithError';
import CommonDropdown from '../../../components/common-dropdown/CommonDropdown';

function DropdownInput({ name, label, isRequired, options, disabled }) {
  const { t } = useTranslation('studio');

  return (
    <WithLabel variant={LABEL_STYLES.COLUMN} label={label} isRequired={isRequired} isBold isTwoDots>
      <Field name={name}>
        {({ input, meta }) => (
          <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)}>
            <CommonDropdown
              size='sm'
              name={name}
              options={options}
              value={input.value ?? ''}
              onSelect={input.onChange}
              placeholder={label}
              isError={meta.touched && meta.error}
              disabled={disabled}
              isTop
            />
          </WithError>
        )}
      </Field>
    </WithLabel>
  );
}

export default DropdownInput;
